import type { ColorsPalette } from 'models/colorsPalette';

const NCAA_PREFIX = 'NCAA-';
const NCAAB_PREFIX = 'NCAAB-';
const NCAAMF_PREFIX = 'NCAAMF-';
const NCAAMB_PREFIX = 'NCAAMB-';

/**
 * Backfill missing NCAA variants across palette prefixes.
 * The source palette JSON currently uses NCAA- keys while markets may reference NCAAMB- or NCAAMF-.
 */
export const applyNcaambPaletteFallback = (
    colorsPalettes: Record<string, ColorsPalette>,
): Record<string, ColorsPalette> => {
    if (!colorsPalettes || Object.keys(colorsPalettes).length === 0) {
        return colorsPalettes;
    }

    let didAdd = false;
    const next = { ...colorsPalettes };

    const maybeAdd = (targetKey: string, value: ColorsPalette) => {
        if (!next[targetKey]) {
            next[targetKey] = value;
            didAdd = true;
        }
    };

    for (const [key, value] of Object.entries(colorsPalettes)) {
        if (key.startsWith(NCAA_PREFIX)) {
            const suffix = key.slice(NCAA_PREFIX.length);
            maybeAdd(`${NCAAB_PREFIX}${suffix}`, value);
            maybeAdd(`${NCAAMB_PREFIX}${suffix}`, value);
            maybeAdd(`${NCAAMF_PREFIX}${suffix}`, value);
            continue;
        }
        if (key.startsWith(NCAAB_PREFIX)) {
            const suffix = key.slice(NCAAB_PREFIX.length);
            maybeAdd(`${NCAA_PREFIX}${suffix}`, value);
            maybeAdd(`${NCAAMB_PREFIX}${suffix}`, value);
            maybeAdd(`${NCAAMF_PREFIX}${suffix}`, value);
            continue;
        }
        if (key.startsWith(NCAAMF_PREFIX)) {
            const suffix = key.slice(NCAAMF_PREFIX.length);
            maybeAdd(`${NCAAB_PREFIX}${suffix}`, value);
            maybeAdd(`${NCAA_PREFIX}${suffix}`, value);
            maybeAdd(`${NCAAMB_PREFIX}${suffix}`, value);
            continue;
        }
        if (key.startsWith(NCAAMB_PREFIX)) {
            const suffix = key.slice(NCAAMB_PREFIX.length);
            maybeAdd(`${NCAAB_PREFIX}${suffix}`, value);
            maybeAdd(`${NCAA_PREFIX}${suffix}`, value);
            maybeAdd(`${NCAAMF_PREFIX}${suffix}`, value);
        }
    }

    return didAdd ? next : colorsPalettes;
};
